import { gql } from "@apollo/client";
import client from "../apolloClient";
import {
  ScreenTag,
  ScreenTagRequest,
  ScreenTagFilters,
  ScreenTagsResponse,
  UpdateScreenTagPayload,
} from "../../schemas/screenTagSchema";

const GET_SCREEN_TAGS = gql`
  query GetScreenTags($page: Int, $pageSize: Int, $search: String) {
    screenTags(page: $page, pageSize: $pageSize, search: $search) {
      screenTags {
        id
        name
        description
        type
        tenantId
        createdBy
        createdAt
        updatedAt
      }
      page
      pageSize
      total
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;

const GET_SCREEN_TAG_BY_ID = gql`
  query GetScreenTagById($id: ID!) {
    screenTag(id: $id) {
      id
      name
      description
      type
      tenantId
      createdBy
      createdAt
      updatedAt
    }
  }
`;

const CREATE_SCREEN_TAG = gql`
  mutation CreateScreenTag($input: CreateScreenTagInput!) {
    createScreenTag(input: $input)
  }
`;

const UPDATE_SCREEN_TAG = gql`
  mutation UpdateScreenTag($id: ID!, $input: UpdateScreenTagInput!) {
    updateScreenTag(id: $id, input: $input)
  }
`;

const DELETE_SCREEN_TAGS = gql`
  mutation DeleteScreenTags($ids: [ID!]!) {
    deleteScreenTags(ids: $ids)
  }
`;

export const screenTagService = {
  getAll: async (
    filters: ScreenTagFilters = {},
  ): Promise<ScreenTagsResponse> => {
    const { data } = await client.query({
      query: GET_SCREEN_TAGS,
      variables: filters,
      fetchPolicy: "network-only",
    });
    return data.screenTags;
  },

  getById: async (id: string): Promise<ScreenTag> => {
    const { data } = await client.query({
      query: GET_SCREEN_TAG_BY_ID,
      variables: { id },
      fetchPolicy: "network-only",
    });
    return data.screenTag;
  },

  create: async (input: ScreenTagRequest): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: CREATE_SCREEN_TAG,
      variables: { input },
    });
    return data.createScreenTag;
  },

  update: async (payload: UpdateScreenTagPayload): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: UPDATE_SCREEN_TAG,
      variables: {
        id: payload.id,
        input: payload.screenTag,
      },
    });
    return data.updateScreenTag;
  },

  remove: async (ids: string[]): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: DELETE_SCREEN_TAGS,
      variables: { ids },
    });
    return data.deleteScreenTags;
  },
};
